import m from "../../geodata/es2015/belgiumLow";
window.am4geodata_belgiumLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/belgiumLow.js
// module id = null
// module chunks = 